function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrownLogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 39",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M3,14L25,26.5L47,14L40.855,39L9.084,39L3,14Z",
    style: {
      fill: "rgb(170,209,42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "M25,8L40,39L10,39L25,8Z",
    style: {
      fill: "rgb(170,209,42)",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 9,
    r: 2,
    style: {
      fill: "rgb(170,209,42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval1",
    serifid: "Oval",
    cx: 25,
    cy: 2,
    r: 2,
    style: {
      fill: "rgb(170,209,42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval2",
    serifid: "Oval",
    cx: 48,
    cy: 9,
    r: 2,
    style: {
      fill: "rgb(170,209,42)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownLogoGreen);
export default __webpack_public_path__ + "static/media/crown-logo-green.dee8dd91.svg";
export { ForwardRef as ReactComponent };